var _require = require('./styled-breakpoints'),
    createStyledBreakpoints = _require.createStyledBreakpoints;

module.exports = createStyledBreakpoints();